import { render, staticRenderFns } from "./FixedAmount.vue?vue&type=template&id=0dd3ac18&scoped=true&"
import script from "./FixedAmount.vue?vue&type=script&lang=ts&"
export * from "./FixedAmount.vue?vue&type=script&lang=ts&"
import style0 from "./FixedAmount.vue?vue&type=style&index=0&id=0dd3ac18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd3ac18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
